<template>
	<div class="change-pin">
	    <div style="position: fixed; top: 50%; left: 50%; z-index: 999;">
	      <atom-spinner
	        v-if="loading"
	        :animation-duration="speed"
	        :size="config.size"
	        :color="spinnersColor"
	      />
	    </div>	
		<div class="row">
	        <div class="flex xs12 md6">
	      		<va-card :title="$t('user.change-password')">
	          		<form @submit.prevent="onsubmit">
	          			<va-input
					        v-model="form.oldpassword"
					        type="password"
					        :label="$t('auth.old-password')"
					        :error="!!oldpasswordErrors.length"
					        :error-messages="oldpasswordErrors"
					        @input = "checklength"
					    />

	          			<va-input
					        v-model="form.password"
					        type="password"
					        :label="$t('auth.new-password')"
					        :error="!!passwordErrors.length"
					        :error-messages="passwordErrors"
					        @input = "checklength"
					    />

					    <va-input
					        v-model="form.confirmpassword"
					        type="password"
					        :label="$t('auth.confirm-password')"
					        :error="!!confirmPasswordErrors.length"
					        :error-messages="confirmPasswordErrors"
					    />
					    <div class="row mt-5">            
			                <va-button type="submit" >
			                  {{ $t('forms.controls.submit') }}
			                </va-button>                        
			            </div>
	          		</form>
	          	</va-card>
	        </div>
	    </div>
	</div>
</template>

<script>
import axios from 'axios'
import * as spinners from 'epic-spinners'

export default {
  components: {
    ...spinners      
  },
  name: 'signup',
  data () {
    return {
      loading:false,
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      form:{
        oldpassword: '',
        password: '',
        confirmpassword:'',        
        user:'',
      },
      oldpasswordErrors: [],
      passwordErrors: [],
      confirmPasswordErrors :[],
      config: {
        size: 80,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      sliderDuration: {
        min: 1000,
        max: 2000,
      },
    }
  },
	computed: {
		speed () {
		  return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
		},
		formReady () {
		  return  !this.passwordErrors.length && !this.oldpasswordErrors.length  && !this.confirmPasswordErrors.length
		},
	},
	methods: {
		checklength(){
		  this.passwordErrors = this.form.password.length != 4 ? ['Enter four digit PIN'] : []
		  if(!this.passwordErrors.length){
		    this.passwordErrors = /^\d+$/.test(this.form.password) ? [] : ['Pin should countain digits only']
		  }     
		},

		onsubmit () {
	      this.oldpasswordErrors = this.form.oldpassword ? [] : ['Old PIN is required']
	      this.passwordErrors = this.form.password ? [] : ['PIN is required']
	      this.confirmPasswordErrors = this.form.confirmpassword ? [] : ['Confirm PIN field is required']
	     

	      if (this.form.password != this.form.confirmpassword) {        
	        this.passwordErrors = ['PINs Do not Match']
	        this.confirmPasswordErrors =  ['PINs Do not Match']
	      }      

	      if (this.formReady) { 
	        var self = this 
	        self.loading = true;  
	        self.disableButton = true;   
	        axios.post(`${this.$apiUrl}UpdatePass`, this.form)
	          .then(function (res) {
	            self.loading = false;	             
	            const response = res.data

	            if (response.success === 1) {	             
	              self.showToast(`Successful! Your PIN Has Been Successfully Updated`, {
	                position: 'bottom-right',
	                icon: "fa-check",
	                duration: 10000,
	              })
	              self.$router.push({ name: 'dashboard' })  
	            }

	            if (response.success === 0) {
	              self.oldpasswordErrors = ['Incorrect PIN']
	              self.showToast(`Input the correct password`, {
	                position: 'bottom-right',
	                icon: "fa-times",
	                duration: 10000,
	              })
	            } 


	          })
	          .catch(function (error) {
	            console.log(error)
	        })
	      }
	    }
	},
	created () {	   
	    this.form.user  = this.userData.user_id
	}
}
</script>
